// Fire a contextual Dana nudge (e.g. from an empty-state screen). The AssistantPanel
// listens for `dana:nudge` and shows a dismissible bubble with this message; an
// optional `question` is asked when the user taps it.
//
// Dedupes per `key` per session so it nudges once (not on every re-render/remount),
// and stays silent if the user dismissed Dana's nudges this session.
export function nudgeDana(opts: { message: string; question?: string; key?: string }): void {
  if (typeof window === 'undefined') return;
  try {
    if (sessionStorage.getItem('dana_nudge_off')) return;
    const k = opts.key ? `dana_nudged_${opts.key}` : null;
    if (k) {
      if (sessionStorage.getItem(k)) return;
      sessionStorage.setItem(k, '1');
    }
  } catch {
    /* sessionStorage unavailable — still nudge */
  }
  window.dispatchEvent(
    new CustomEvent('dana:nudge', { detail: { message: opts.message, question: opts.question } }),
  );
}
